import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import './barchat.scss';
import { BarChart } from '@mui/x-charts/BarChart';
import Box from '@mui/material/Box';
import { LineChart } from '@mui/x-charts/LineChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import dayjs from "dayjs";

const EnthChart = (props) => {
  const chartref = useRef(null);



  const chartSetting = {
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "rotate(90deg) translate(55px, -150px)"
      },
      /*[`.${axisClasses.bottom} .${axisClasses.tickLabel}`]: {
        transform: "rotateZ(-45deg) translate(-20px, 10px)"
        //.style("text-anchor", "end");
      }*/
    }
  };


  const valueFormatter = (value: number | null) => `${value}mm`;




  function graphUniversalsOLD() {

    //console.log(props.chartData,'barChartValues')
    //console.log(props.barChart,'barChartValues')

    d3.select(chartref.current).selectAll("svg").remove();
    var sNDF = "No Data Found.";
    var sSource = "Universals";
    var sCopyright = "Copyright - Geppetto's Workshop LLC.  All Rights Reserved";
    var dataItem = [
      // [
      //   {  c1: 48, c2: "Mike Schmidt" },
      //   {  c1: 41, c2: "Reggie Jackson" },
      //   {  c1: 41, c2: "Ben Oglivie" },
      //   {  c1: 38, c2: "Gorman Thomas" },
      //   {  c1: 35, c2: "Tony Armas" },
      //   {  c1: 35, c2: "Bob Horner" },
      //   {  c1: 33, c2: "Dale Murphy" },
      //   {  c1: 32, c2: "Eddie Murray" },
      //   {  c1: 30, c2: "John Mayberry" },
      //   {  c1: 29, c2: "Dusty Baker" },
        
      // ],
      props.barChartValues
    ];
    var element = document.getElementById("chart");
    // var svg = d3.select(chartref.current).append("svg").attr("width", width).attr("height", height);
    //var positionInfo = element.getBoundingClientRect();
    var positionInfo = element.getBoundingClientRect();  //20240329 jag added back from java
    var height = positionInfo.height; //20240329 jag added back from java
    var width = positionInfo.width;//20240329 jag added back from java

  //var height = 700; //20240329 jag softura hardcode not good
  //var width = 1000; //20240329 jag softura hardcode not good
    var middle = width / 2;
    var heightMIN = 200;
    var margin = { top: 10, right: 20, bottom: 60, left: 50 };
    width = width - margin.left - margin.right;
    height = width * 0.5 - margin.top - margin.bottom;
    height = Math.max(height, heightMIN);
    if (dataItem == null) {
      // var win = d3.select(".chart");
      // var svg = d3
      //   .select(".chart")
      //   .append("svg")
      //   .attr("width", width)
      //   .attr("height", height)
      //   .attr("viewBox", "0 0 680 490")
      //   .append("g")
      //   .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
      var svgContainer = d3.select(".chart").append("svg") 
      svgContainer
        .append("text")
        .attr("x", 10)
        .attr("y", 40)
        .attr("text-anchor", "start")
        .style("font-size", "16px")
        .style("font-weight", "normal")
        .text(sNDF);
    } else {
      var x = d3
        .scaleBand()
        .range([0, width - margin.right - margin.left], 0.1)
        .padding(0.1)
        .domain(
          dataItem[0].map(function (d) {
            return d.c2;
          })
        );
      var y = d3
        .scaleLinear()
        .range([height, margin.top + 25])
        .domain([
          0,
          d3.max(dataItem[0], function (d) {
            return d.c1;
          }) * 1.1,
        ]);
      var chart = d3
        .select("#chart")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .attr("viewBox", "0 0 1000 500")

        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      chart
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x))
        .selectAll("text")
        .attr("y", 5)
        .attr("x", -5)
        .attr("transform", "rotate(-30)")
        .style("text-anchor", "end");
      chart.append("g").call(d3.axisLeft(y));
      chart
        .append("text")
        .style("font-size", "12px")
        .attr("y", 10)
        .attr("x", 0)
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .text("HR");
      chart
        .append("g")
        .selectAll(".bar")
        .data(props.barChartValues)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("class", "aggregate0")
        .attr("x", function (d) {
          return x(d.c2) + (x.bandwidth() - Math.min(x.bandwidth() - 2, 60)) / 2;
        })
        .attr("y", function (d) {
          return y(d.c1);
        })
        .attr("height", function (d) {
          return height - y(d.c1);
        })
        .attr("width", Math.min(x.bandwidth() - 2, 60));
      var wLegend = 90;
      var hLegend = 200;
      var xLegend = width + margin.left - wLegend - 80;
      var yLegend = -15;
      chart
        .append("text")
        .attr("x", xLegend + wLegend / 2)
        .attr("y", yLegend + 20)
        .attr("text-anchor", "middle")
        .style("font-size", "12px")
        .text("Legend");
      chart
        .append("text")
        .attr("x", xLegend + 40)
        .attr("y", yLegend + 45 + 0 * 20)
        .attr("text-anchor", "end")
        .style("font-size", "10px")
        .text("HR");
      chart
        .append("rect")
        .attr("x", xLegend + 50)
        .attr("y", yLegend + 33 + 0 * 20)
        .attr("width", wLegend - 60)
        .attr("height", 15)
        .attr("class", "aggregate0");
    }

    const type = (d) => {
      d.Year = +d.Year;
      d.c1 = +d.c1;
      d.c2 = +d.c2;
      return d;
    };
  }

  function graphUniversals() {

    //console.log(props.chartData,'barchart');
    //console.log(props.barChartDataX, 'test');

    d3.select(chartref.current).selectAll("svg").remove();
    var sNDF = "No Data Found.";
    var sSource = "XXXX";
    var sCopyright = "Copyright - XXXX.  All Rights Reserved";
    var dataItem = [
      // [
      //   {  c1: 48, c2: "Mike Schmidt" },
      //   {  c1: 41, c2: "Reggie Jackson" },
      //   {  c1: 41, c2: "Ben Oglivie" },
      //   {  c1: 38, c2: "Gorman Thomas" },
      //   {  c1: 35, c2: "Tony Armas" },
      //   {  c1: 35, c2: "Bob Horner" },
      //   {  c1: 33, c2: "Dale Murphy" },
      //   {  c1: 32, c2: "Eddie Murray" },
      //   {  c1: 30, c2: "John Mayberry" },
      //   {  c1: 29, c2: "Dusty Baker" },
        
      // ],
      props.barChartValues
    ];
    var element = document.getElementById("chart");
    // var svg = d3.select(chartref.current).append("svg").attr("width", width).attr("height", height);
    //var positionInfo = element.getBoundingClientRect();
    var positionInfo = element.getBoundingClientRect();  //20240329 jag added back from java
    var height = positionInfo.height; //20240329 jag added back from java
    var width = positionInfo.width;//20240329 jag added back from java

  //var height = 700; //20240329 jag softura hardcode not good
  //var width = 1000; //20240329 jag softura hardcode not good
    var middle = width / 2;
    var heightMIN = 250;
    var margin = { top: 10, right: -15, bottom: 120, left: 80 };
    width = width - margin.left - margin.right;
    height = width * 0.5 - margin.top - margin.bottom;
    height = Math.max(height, heightMIN);
    if (dataItem == null) {
      var win = d3.select(".chart");
      var svg = d3
        .select(".chart")
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", "0 0 680 490")
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
      var svgContainer = d3.select(".chart").append("svg") 
      svgContainer
        .append("text")
        .attr("x", 10)
        .attr("y", 40)
        .attr("text-anchor", "start")
        .style("font-size", "16px")
        .style("font-weight", "normal")
        .text(sNDF);
    } else {
      var x = d3
        .scaleBand()
        .range([0, width - margin.right - margin.left], 0.1)
        .padding(0.1)
        .domain(
          dataItem[0].map(function (d) {
            return d.c2;
          })
        );
      var y = d3
        .scaleLinear()
        .range([height, margin.top + 25])
        .domain([
          0,
          d3.max(dataItem[0], function (d) {
            return d.c1;
          }) * 1.1,
        ]);
      var chart = d3
        .select("#chart")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        
        .attr("height", height + margin.top + margin.bottom)
        
      // .append("g")
        //.attr("transform", translate(margin.left, margin.top ));
        .attr("viewBox", "-25 0 500 250");

        //window.alert(width);
        //window.alert(height);

      
      chart
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x))
        .selectAll("text")
        .attr("y", 5)
        .attr("x", -5)
        .attr("transform", "rotate(-30)")
        .style("text-anchor", "end");
      chart.append("g").call(d3.axisLeft(y));
      chart
        .append("text")
        .style("font-size", "12px")
        .attr("y", 10)
        .attr("x", 0)
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .text("HR");
      chart
        .append("g")
        .selectAll(".bar")
        .data(props.barChartValues)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("class", "aggregate0")
        .attr("x", function (d) {
          return x(d.c2) + (x.bandwidth() - Math.min(x.bandwidth() - 2, 60)) / 2;
        })
        .attr("y", function (d) {
          return y(d.c1);
        })
        .attr("height", function (d) {
          return height - y(d.c1);
        })
        .attr("width", Math.min(x.bandwidth() - 2, 60));
      var wLegend = 90;
      var hLegend = 200;
      var xLegend = width + margin.left - wLegend - 80;
      var yLegend = -15;
      chart
        .append("text")
        .attr("x", xLegend + wLegend / 2)
        .attr("y", yLegend + 20)
        .attr("text-anchor", "middle")
        .style("font-size", "12px")
        .text("Legend");
      chart
        .append("text")
        .attr("x", xLegend + 40)
        .attr("y", yLegend + 45 + 0 * 20)
        .attr("text-anchor", "end")
        .style("font-size", "10px")
        .text("HR");
      chart
        .append("rect")
        .attr("x", xLegend + 50)
        .attr("y", yLegend + 33 + 0 * 20)
        .attr("width", wLegend - 60)
        .attr("height", 15)
        .attr("class", "aggregate0");
    }

    const type = (d) => {
      d.Year = +d.Year;
      d.c1 = +d.c1;
      d.c2 = +d.c2;
      return d;
    };
  }

  //original
  /*useEffect(()=>{
    graphUniversals()
  },[props.chartData])
    return (
      <div id="chart" className="chart-container" ref={chartref}>
        
      </div>
    );*/

  useEffect(()=>{
  //graphUniversals();
  },[props.barChartDetails, props.barChartValues, props.chartWidth])
    return (
      <div id="chart" className="chart-container" ref={chartref}>
        <BarChart
          dataset={props.barChartValues}
          
          colors={['#6EBE44',
            'teal',
            'LightSeaGreen',
            'MediumAquamarine',
            'MediumSeaGreen',
            'ForestGreen',
            'DarkGreen',
            'DarkSeaGreen',
            '#2B7BBC']}

          xAxis={[{ scaleType: 'band', 
            //transform: 'rotateZ(-45deg)',
            dataKey: props.barChartDetails['xaxis'],
            tickLabelStyle: {
              angle: -45,
              textAnchor: 'end',
              fontSize: 12}
          }]}

          yAxis={[{scaleType: 'linear',
            label: props.barChartDetails['yaxis']}]}
        
          width={props.chartWidth}
          height={300}
          
          series={[{ dataKey: props.barChartDetails['yaxis'], 
            label: props.barChartDetails['yaxis'], 
            valueFormatter }]}

            {...chartSetting}
        />
      </div>
    );
  };

export default EnthChart;

